<div class="modalPlans">
    <div class="contenidoModal">
      <div class="header">
        <img src="/assets/icono-plans/alertamin.svg" alt="alerta">
        <img src="/assets/icono/equis.svg" class="cerrar mr-2" (click)="closeModal(false)" alt=""/>
      </div>
     <div class="bajada">
        <h2 class="copec-bold-16" >{{titulo}}</h2>
         <span class>{{mensaje}}</span>    
      </div>
      <div class="botones" style="display:flex; justify-content:space-between; gap:16px; margin-top:18px; padding:0 18px; margin-bottom:12px;">
        <button
          class="cambiarme"
          (click)="closeModal(false)"
          style="flex:1; background:transparent; border:1px solid #588dee; color:#2066e9; border-radius:6px; padding:10px 12px;">
          Cancelar
        </button>
        <button
          class="cambiarme"
          (click)="closeModal(true)"
          style="flex:1; background:#588dee; border:1px solid #588dee; color:#fff; border-radius:6px; padding:10px 12px;">
          Aceptar
        </button>
      </div>

</div>
